export const colors = {
    green: '#297A71',
    white: 'rgba(255, 255, 255)',
    gray: '#E5E5E5',
    black: 'rgba(0, 0, 0)',
    borderColorLight: 'rgba(0, 0, 0, .1)',
    borderColor: 'rgba(0, 0, 0, 0.2)',
    labelColor: 'rgba(0, 0, 0, 0.4)',

    green200: 'rgba(41, 122 , 113, .1)', // #297A71 , opacity: .1
    green400: 'rgba(41, 122 , 113, .3)', // #297A71 , opacity: .3
    green500: 'rgb(41, 122 ,113)', // #297A71
    green600: 'rgb(24, 90, 81)', // #185A51

    redLight100: '#FCE7EA',
    red100: 'rgba(166, 25, 46, .1)',
    red200: '#F6E8EA',
    red300: 'rgb(220, 120, 130)',
    red500: 'rgb(166, 25, 46)',
    red600: 'rgb(140, 21, 61)',

    caseRed500: '#910012',

    orange500: 'rgb(220, 107, 47)',
    orange600: 'rgba(220, 93, 47)',

    disabledBackground: 'rgb(245, 246, 248)',
    gray500: 'rgba(0, 0, 0, .05)',
    gray600: 'rgba(0, 0, 0, .1)',
    gray700: 'rgba(0, 0, 0, 0.2)',
    gray800: 'rgba(0, 0, 0, 0.4)',
    gray900: 'rgba(86, 88, 90, 0.9)',

    blue300: '#E9F4F3',

    error: 'rgb(235, 52, 52)',
    errorBg: 'rgb(235, 52, 52, .1)',
}

const palette = {
    colors,
    link: {},
    foreground: colors.green,
    background: colors.gray,
    navBackgroundColor: colors.white,
    borderColor: colors.green,
    backgroundOpaque: 'rgba(255,255,255,0.9)',
    primary: '#464646', // Text
    secondary: '#fff', // Text
    buttonPrimary: colors.green,
    creme: '#dccab8',
    CTAhover: '#323232',
}

export default palette
